export default __webpack_public_path__ + "static/media/sell-image1.7bc9b642.png";